import { client } from "Service/axios";
import { ILetter } from "Shared/Types/letter";





const ORDER_URL = "letters/send/";



class Letter {
    sendLetter(data: ILetter) {
        return client.post(`${ORDER_URL}`, data);
    }
}

export default Letter;

